export default __webpack_public_path__ + "static/media/finishedCircle-default.af5f5f45.png";